/**
 * 系统管理  课程库管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" v-if="flag != 2">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>课程库管理</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search" @submit.native.prevent>
      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryParams.kcmc" placeholder="输入课程名称"></el-input>
      </el-form-item>
      <el-form-item label="" style="width: 400px;" class="pxkm">
        <el-cascader
          size="small"
          style="width: 100%"
          v-model="queryParams.subjectId"
          :options="treeOptions"
          emitPath="false"
          :props="{ emitPath:false }"
          placeholder="请选择培训科目"
          clearable
        ></el-cascader>
      </el-form-item>
<!--      <el-form-item label="">
        <el-input size="small" v-model="queryParams.jsmc" placeholder="输入教室名称"></el-input>
      </el-form-item>-->
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()" v-if="flag != 2">添加</el-button>
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table
      ref="tableBox1"
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      :row-key="(row) => { return row.id }"
    >
      <el-table-column type="selection" width="55" align="center" :reserve-selection="true" v-if="flag == 2"/>
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60">
      </el-table-column>
      <el-table-column prop="kcmc" label="课程名称">
      </el-table-column>
      <el-table-column prop="subjectName" label="培训科目">
      </el-table-column>
<!--      <el-table-column prop="kssj" label="开始时间">
      </el-table-column>
      <el-table-column prop="jssj" label="结束时间">
      </el-table-column>-->
      <el-table-column prop="xs" label="学时">
      </el-table-column>
<!--      <el-table-column prop="jsmc" label="教室">
      </el-table-column>-->
      <el-table-column align="center" label="操作" width="200" v-if="flag != 2">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              @click="handleEdit(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="deleteUser(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>
<!--          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>


    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="50%" :close-on-click-modal="false" @click="closeDialog">
      <el-form label-width="120px" :model="form" :rules="rules" ref="form">
        <el-form-item label="课程名称" prop="kcmc">
          <el-input size="small" v-model="form.kcmc" placeholder="请输入" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="培训科目" prop="subjectId">
          <el-cascader
            size="small"
            style="width: 100%"
            v-model="form.subjectId"
            :options="treeOptions"
            emitPath="false"
            :props="{ emitPath:false }"
            clearable
          ></el-cascader>
        </el-form-item>
<!--        <el-form-item label="开始时间" prop="kssj">
          <el-date-picker size="small" type="datetime" placeholder="选择开始时间" v-model="form.kssj" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="jssj">
          <el-date-picker size="small" type="datetime" placeholder="选择结束时间" v-model="form.jssj" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>-->
        <el-form-item label="学时" prop="xs">
          <el-input size="small" v-model="form.xs" placeholder="请输入" @input="formatInportData($event,'4','xs',form)"></el-input>
        </el-form-item>
<!--        <el-form-item label="教室" prop="jsmc">
          <el-input size="small" v-model="form.jsmc" placeholder="请选择" readonly @click.native="openRoom = true"></el-input>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择教室" :visible.sync="openRoom" width="70%" :close-on-click-modal="false" @click="openRoom = false">
      <Classroom :flag="2" v-on:roomData="roomData"></Classroom>
    </el-dialog>

    <div style="text-align: right;" v-if="flag == 2">
      <el-button type="primary" @click="submitData">确定</el-button>
    </div>

  </div>
</template>

<script>
import { getCourseList, addCourse, editCourse, deleteCourseById } from '../../api/course'
import Pagination from '../../components/Pagination'
import Classroom from '../system/classroom.vue'
import {formatInportData, timestampToTime} from "../../utils/util";
import {selectAreaTree} from "../../api/subjectTree";

export default {
  props: {
    flag: {
      type: Number,
      default: 1
    },
    toList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    subjectId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      courseList: '',

      treeOptions: undefined,

      // 教室信息
      openRoom: false,
      roomList: [],

      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '添加',
      form: {},
      // rules表单验证
      rules: {
        kcmc: [
          { required: true, message: '请输入课程名称', trigger: 'blur' }
        ],
        subjectId: [
          { required: true, message: '请输入培训科目', trigger: 'blur' }
        ],
        /*kssj: [
          { required: true, message: '请选择开始时间', trigger: 'blur' }
        ],
        jssj: [
          { required: true, message: '请选择结束时间', trigger: 'blur' }
        ],*/
        xs: [
          { required: true, message: '请输入学时', trigger: 'blur' }
        ],
        /*jsmc: [
          { required: true, message: '请选择教室', trigger: 'change' }
        ],*/
      },
      queryParams: {
        page: 1,
        size: 10,
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
    Classroom
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.initData();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    formatInportData,
    timestampToTime,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    initData() {
      this.getdata();
      this.selectAreaTree();
    },
    // 查询 科目树
    selectAreaTree() {
      selectAreaTree({}).then(res => {
        if (res.code == 200) {
          this.treeOptions = res.data;
        }
      })
    },
    // 获取营销渠道列表
    getdata() {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */

      if (this.subjectId) {
        this.queryParams.subjectId = this.subjectId;
      }
      getCourseList(this.queryParams).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.content;

          if (this.toList.length > 0) {
            var list = [];

            this.listData.forEach(x => {
              this.toList.forEach(y => {
                if (x.id == y.id) {
                  list.push(x);
                }
              })
            })

            this.$nextTick(() => {
              list.forEach(x => {
                this.$refs.tableBox1.toggleRowSelection(x, true);
              })
            })
          }

          // 分页赋值
          this.pageparm = res.data.pageparm
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.getdata()
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      console.log('selection  ', selection);
      this.courseList = selection;
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormShow = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.form = JSON.parse(JSON.stringify(row))
      } else {
        this.title = '添加'
        this.form = {}
      }
    },
    roomData(item) {
      this.$set(this.form, 'roomId', item.id)
      this.$set(this.form, 'jsmc', item.jsmc);

      this.openRoom = false;
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {

          /*const start = new Date(this.form.kssj);
          const end = new Date(this.form.jssj);

          if (end <= start) {
            this.$message.error('结束时间必须大于开始时间');
            return;
          }

          const diffInMinutes = (end - start) / (1000 * 60); // 计算时间差（分钟）
          const periods = Math.floor(diffInMinutes / 45); // 计算学时

          console.log('periods   ', periods);
          console.log('this.form.xs   ', this.form.xs);

          if (Number(this.form.xs) > periods) {
            this.$message.error('该课学时时长不能超过' + periods);
            return;
          }*/

          if (this.form.id) {

            // 修改
            editCourse(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          } else {

            // 新增
            addCourse(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }


        } else {
          return false
        }
      })
    },
    // 删除营销渠道
    deleteUser(index, row) {
      this.$confirm('确定要删除该条数据吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteCourseById(row.id).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('删除失败，请稍后再试！')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormShow = false
    },

    submitData() {
      if (this.courseList.length > 0) {
        this.$emit('courseListData', this.courseList);
      } else {
        this.$message.error('请勾选需要的课程数据...')
      }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

.pxkm /deep/ .el-form-item__content {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/course/courseManage.vue